import RevxFlexLayout from 'components/RevxFlexLayout';
import { ConfigSvcProps } from '..';
import CommonJobSvcBorder from '../common/CommonJobSvcBorder';
import CommonJobSvcCotainer from '../common/CommonJobSvcCotainer';
import CommonJobSvcInstructions from '../common/CommonJobSvcInstructions';
import CommonJobSvcMessage from '../common/CommonJobSvcMessage';
import CommonJobSvcName from '../common/CommonJobSvcName';
import CommonJobSvcOption from '../common/CommonJobSvcOption';
import CommonJobSvcSpec from '../common/CommonJobSvcSpec';
import CommonQuantityPerBundle from '../common/CommonQuantityPerBundle';
import { useHideSvc } from '../hook/useHideSvc';
import { useHideSvcContainer } from '../hook/useHideSvcContainer';

const CrashNumbering = (props: ConfigSvcProps) => {
  const hideSvc = useHideSvc(props);

  const hideSvcContainer = useHideSvcContainer(props);

  // const colorRadioProps: RevxRadioProps = {
  //   outSideRevxLayoutProps: {
  //     align: 'top',
  //     justify: 'left',
  //     wrap: 'wrap',
  //     className: 'jobconfig-jobOption-content-outSideOption-default',
  //     style: {
  //       paddingBottom: 0,
  //       marginTop: 20,
  //     },
  //   },
  //   inSideRevxLayoutProps: {
  //     align: 'top',
  //     justify: 'left',
  //     className: 'jobconfig-jobOption-content-inSideOption-default',
  //     style: {
  //       marginRight: 31,
  //     },
  //   },
  //   options: [
  //     {
  //       value: 'Red',
  //       children: <span>Red</span>,
  //     },
  //     {
  //       value: 'Black',
  //       children: <span>Black</span>,
  //     },
  //   ],
  // };
  // const prefixRadioProps: RevxRadioProps = {
  //   outSideRevxLayoutProps: {
  //     align: 'top',
  //     justify: 'left',
  //     wrap: 'wrap',
  //     className: 'jobconfig-jobOption-content-outSideOption-default',
  //     style: {
  //       paddingBottom: 0,
  //       marginTop: 20,
  //     },
  //   },
  //   inSideRevxLayoutProps: {
  //     align: 'top',
  //     justify: 'left',
  //     className: 'jobconfig-jobOption-content-inSideOption-default',
  //     style: {
  //       marginRight: 22,
  //     },
  //   },
  //   options: [
  //     {
  //       value: 'None',
  //       children: <span>None</span>,
  //     },
  //     {
  //       value: '#',
  //       children: <span>#</span>,
  //     },
  //     {
  //       value: 'No.',
  //       children: <span>No.</span>,
  //     },
  //   ],
  // };

  return (
    <>
      <div style={hideSvc}>
        <RevxFlexLayout align="top" justify="justify-start">
          <CommonJobSvcName {...props} />
          <div>
            <CommonJobSvcCotainer {...props}>
              <CommonJobSvcSpec {...props} disabled={hideSvcContainer} />
              <CommonJobSvcOption {...props} disabled={hideSvcContainer} />
              {/* <RevxFlexLayout>
            <div style={{ marginRight: 10 }}>
              <div
                className="jobconfig-jobOption-content-label"
                style={{ margin: '21px 0 14px 0' }}
              >
                Color
              </div>
              <Form.Item name={[id, 'Color']} noStyle>
                <RevxRadio {...colorRadioProps} />
              </Form.Item>
            </div>
            <div>
              <div
                className="jobconfig-jobOption-content-label"
                style={{ margin: '21px 0 14px 0' }}
              >
                Prefix
              </div>
              <Form.Item name={[id, 'Prefix']} noStyle>
                <RevxRadio {...prefixRadioProps} />
              </Form.Item>
            </div>
          </RevxFlexLayout> */}
              <CommonQuantityPerBundle {...props} disabled={hideSvcContainer} />
              <CommonJobSvcInstructions
                {...props}
                disabled={hideSvcContainer}
              />
              <CommonJobSvcMessage {...props} disabled={hideSvcContainer} />
            </CommonJobSvcCotainer>
          </div>
        </RevxFlexLayout>
        <CommonJobSvcBorder />
      </div>
    </>
  );
};

export default CrashNumbering;
